import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useResponsive } from '../hooks/useResponsive';
import { isAdminUser } from '../utils/roles';

const AdminRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { user, loading } = useAuth();
  const { isMobile } = useResponsive();

  // eslint-disable-next-line no-console
  console.log('🔐 AdminRoute - Estado:', { loading, user: user ? { email: user.email, role: user.role } : null });

  // Loading state
  if (loading) {
    // eslint-disable-next-line no-console
    console.log('🔐 AdminRoute - Mostrando loading...');
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        backgroundColor: '#181A1B',
        color: 'var(--text-primary)',
        marginLeft: isMobile ? 0 : '110px'
      }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{ fontSize: '24px', marginBottom: '16px' }}>&#9881;</div>
          <div>Cargando...</div>
        </div>
      </div>
    );
  }

  // Si no hay usuario, redirigir a la pagina principal (landing/login)
  if (!user) {
    // eslint-disable-next-line no-console
    console.log('🔐 AdminRoute - No hay usuario, redirigiendo a /');
    return <Navigate to="/" replace />;
  }

  // Check if user has admin permissions
  const isAdmin = isAdminUser(user);
  // eslint-disable-next-line no-console
  console.log('🔐 AdminRoute - isAdmin:', isAdmin, 'role:', user.role);

  if (!isAdmin) {
    // User is authenticated but not an admin - redirect to home
    // eslint-disable-next-line no-console
    console.log('🔐 AdminRoute - No es admin, redirigiendo a /home');
    return <Navigate to="/home" replace />;
  }

  // User is authenticated and has admin permissions
  return <>{children}</>;
};

export default AdminRoute;
